<template>
    <div class="leftMenu">       
        <div class="menu-box">
            <div class="m-list">
                <h3>我的业务</h3>
                <div class="l-menu" :class="{'isActive': (active==3)}"  @click="goPath('/release')">公示公告发布</div>           
                <div class="l-menu" :class="{'isActive': (active==1)}"  @click="goPath('/notice')">公示公告存证</div>
            </div>
            <div class="m-list">
                <h3>我的信息</h3>
                <div class="l-menu" :class="{'isActive': (active==2)}" @click="goPath('/nUser')">会员信息</div>
                <div class="l-menu" :class="{'isActive': (active==4)}" @click="goPath('/nPwd')">修改密码</div>
            </div>
            <!-- <el-collapse v-model="cActive">
                <el-collapse-item name="1">
                    <template slot="title">我的业务</template>
                    <div class="l-menu" @click="goPath('/notice')">公示公告</div>
                </el-collapse-item>
                <el-collapse-item name="2">
                    <template slot="title">我的信息</template>
                    <div class="l-menu" @click="goPath('/nUser')">个人/企业信息</div>
                </el-collapse-item>       
            </el-collapse>                                     -->
        </div>
    </div>
</template>
<script>
export default {
    name: 'leftMenu',
    props: ['active'],
    data() {
        return {
            cActive: []
        }
    },
    created() {
        this.cActive[0] = this.active+''
    },
    methods: {
        goPath(url){
            this.$router.push({path: url});
        }
        
    }
}
</script>